import React, { useState, useEffect } from 'react';
import { Spin } from 'antd';
import api from '../services/api';
import PageSkeleton, { ListSkeleton } from '../components/Skeleton';

const INK = '#18140C';
const INK3 = '#7A7268';
const MUTED = '#685840';
const BG = '#FAF8F5';
const BD = '#E8E0D0';
const GRN = '#2E7D4F';
const GOLD = '#B8892A';
const BLUE = '#1A4F8C';

const CARRIER = { dhl: 'DHL', ems: 'EMS', yamato: '雅玛多', sagawa: '佐川急便', fedex: 'FedEx', other: '其他' };
const STATUS = {
  pending:          { label: '待发货', color: MUTED },
  warehouse:        { label: '仓库集货', color: MUTED },
  customs:          { label: '清关中', color: GOLD },
  in_transit:       { label: '运输中', color: BLUE },
  out_for_delivery: { label: '派送中', color: BLUE },
  delivered:        { label: '已签收', color: GRN },
  returned:         { label: '已退回', color: '#C0392B' },
  exception:        { label: '异常', color: '#C0392B' },
};

function fmt(d) { return d ? new Date(d).toLocaleString('zh-CN', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—'; }

export default function Logistics() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    api.get('/shipments/mine')
      .then(({ data }) => setRows(data.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <ListSkeleton rows={5} />;

  return (
    <div style={{ background: BG, minHeight: '100vh', padding: '20px 16px 40px', fontFamily: 'var(--sans,sans-serif)' }}>
      <div style={{ maxWidth: 560, margin: '0 auto' }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, color: INK, marginBottom: 4 }}>物流单</h2>
        <p style={{ fontSize: 12, color: INK3, marginBottom: 18 }}>查看您的国际物流单及运输轨迹</p>

        {rows.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '70px 20px', color: INK3 }}>
            <div style={{ fontSize: 44, marginBottom: 14, opacity: .25 }}>📦</div>
            <div style={{ fontSize: 14 }}>暂无物流单</div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {rows.map(s => {
              const st = STATUS[s.status] || { label: s.status, color: MUTED };
              let events = [];
              try { events = typeof s.events === 'string' ? JSON.parse(s.events) : (s.events || []); } catch {}
              const open = openId === s.id;
              return (
                <div key={s.id} style={{ background: '#fff', border: `1px solid ${BD}`, borderRadius: 12, overflow: 'hidden' }}>
                  <button onClick={() => setOpenId(open ? null : s.id)} style={{
                    width: '100%', padding: 14, background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left',
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                      <span style={{ fontSize: 13, fontWeight: 600, color: INK }}>
                        {CARRIER[s.carrier] || s.carrier}
                        <span style={{ fontFamily: 'var(--mono,monospace)', fontSize: 12, color: MUTED, marginLeft: 8 }}>{s.tracking_no}</span>
                      </span>
                      <span style={{ fontSize: 12, fontWeight: 600, color: st.color, padding: '2px 10px', borderRadius: 10, background: `${st.color}14` }}>{st.label}</span>
                    </div>
                    <div style={{ fontSize: 12, color: MUTED, lineHeight: 1.5, display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                      {s.item_titles || '拍品'}{s.item_count > 1 ? ` 等${s.item_count}件` : ''}
                    </div>
                    <div style={{ display: 'flex', gap: 16, marginTop: 8, fontSize: 11, color: INK3 }}>
                      <span>发货 {fmt(s.shipped_at)}</span>
                      <span>{s.delivered_at ? `签收 ${fmt(s.delivered_at)}` : (s.estimated_delivery ? `预计 ${fmt(s.estimated_delivery)}` : '')}</span>
                    </div>
                  </button>

                  {open && events.length > 0 && (
                    <div style={{ borderTop: `1px solid ${BD}40`, padding: '12px 14px', background: '#FCFBF8' }}>
                      {events.slice().reverse().map((ev, i) => (
                        <div key={i} style={{ display: 'flex', gap: 10, paddingBottom: 10 }}>
                          <span style={{ width: 7, height: 7, borderRadius: '50%', background: i === 0 ? GRN : BD, marginTop: 5, flexShrink: 0 }} />
                          <div>
                            <div style={{ fontSize: 12, color: INK }}>{ev.desc || ev.status || ev.text || ''}</div>
                            <div style={{ fontSize: 11, color: INK3 }}>{fmt(ev.time || ev.at || ev.timestamp)}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  {open && events.length === 0 && (
                    <div style={{ borderTop: `1px solid ${BD}40`, padding: '12px 14px', fontSize: 12, color: INK3 }}>暂无轨迹更新</div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
